import Button from "devextreme-react/button";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function ExitButton() {

	const navigate = useNavigate();
	let [params] = useSearchParams();
	const returnUrl = params.get("returnUrl");

	return (
		<Button elementAttr={{ 'data-testid': 'btn-exit' }}
			text="Exit"
			icon="Inscyth-Exit"
			visible={!!returnUrl}
			type="danger"
			onClick={() => { navigate(returnUrl!); }} >
		</Button>
	)
}
